<template>
  <el-container class="aff-login" v-loading="loading">
    <common-aside></common-aside>
    <el-main class="content">
      <div class="header">
        <div class="logo">
          <a href="https://www.youmi.net/en/" target="_blank">
            <img src="../../assets/img/Ym-logo2x.png" alt="LOGO" class="logo-img" />
          </a>
        </div>
        <router-link to="/register">
          <div class="signup overlay-btn">
            <span>Sign Up</span>
          </div>
        </router-link>
      </div>
      <div class="main-container">
        <el-form
          :model="login"
          v-if="page_level == 1"
          :rules="rules"
          ref="loginForm"
          class="login-form"
        >
          <div class="login-title">
            <div>Login</div>
            <div>Welcome to Youmi!</div>
          </div>
          <el-form-item prop="username">
            <label class="ym-label">Email</label>
            <el-input
              class="login-input"
              type="text"
              autocomplete="off"
              v-model="login.username"
              name="username"
            ></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <label class="ym-label">Password</label>
            <el-input
              class="login-input"
              type="password"
              autocomplete="off"
              v-model="login.password"
              name="password"
              @keyup.native="$event.keyCode == 13 ? Login() : ''"
            ></el-input>
          </el-form-item>
          <el-form-item v-if="login_captcha_enable" prop="captcha">
            <label class="ym-label">Verification Code</label>
            <el-input
              class="login-input"
              v-model="login.captcha"
              name="captcha"
              @keyup.native="$event.keyCode == 13 ? Login() : ''"
            >
              <template slot="append">
                <img
                  id="login_captcha"
                  class="captcha-img"
                  @click="src = '/api/common/get-captcha/?' + Math.random()"
                  :src="src"
                  alt="captcha"
                  style="vertical-align: middle;height: 46px;"
                />
              </template>
            </el-input>
          </el-form-item>
          <el-form-item>
            <div class="remember-box">
              <!--              <div>-->
              <!--                <el-checkbox id="remember" name="remember"></el-checkbox>-->
              <!--                <label class="remember-label">Remember me</label>-->
              <!--              </div>-->
              <div>
                <a class="forget" @click="page_level = 4">Forgot Password?</a>
              </div>
            </div>
          </el-form-item>
          <el-form-item>
            <el-button class="login-btn overlay-btn" type="primary" @click="Login">Login</el-button>
          </el-form-item>
        </el-form>

        <!--邮箱未验证-->
        <el-form v-if="page_level == 2" class="verify-form">
          <h2 class="verify-title">
            <div>Login</div>
            <div>Welcome to Youmi!</div>
          </h2>
          <div class="verify-content">
            <div class="verify-sub-tit">
              <i class="icon-y-warning mr-1" style="color: #FF9933;font-size: 24px"></i>
              <label>Activate your account</label>
            </div>
            <div class="check">Check your email address:</div>
            <div class="email">{{ login.username }}</div>
            <div class="desc">
              We have sent you an email, please click the link in the email to activate your
              account. If you can't find the mail, please check the spam.
            </div>
            <div class="btn-area">
              <el-button class="back-login verify-btn overlay-btn" @click="page_level = 1">
                Back to Login
              </el-button>
              <el-button class="go-check verify-btn overlay-btn" @click="checkEmail">
                Go and Check
              </el-button>
            </div>
            <div class="no-email"><a @click="page_level = 3">No email received?</a></div>
          </div>
        </el-form>

        <!--未收到邮件-->
        <el-form v-if="page_level == 3" class="no-email-form">
          <h2 class="no-email-title">
            <div>Login</div>
            <div>Welcome to Youmi!</div>
          </h2>
          <div class="no-email-content">
            <div class="no-email-sub-tit">
              <i class="icon-y-yiwen1 mr-1" style="color: #FF9933;font-size: 24px"></i>
              <span class="sub-tit">No Mail Received?</span>
            </div>
            <div class="solutions">Try the following solutions:</div>
            <p class="solutions-content">
              1. Please wait for a few minutes in case of network latency.
              <br />
              2. Don't forget to check your junk email in case of spam filtering.
              <br />
              3. Please double check your email address.
              <br />
              4. Send again.
              <a @click="sendEmailAgain">Click here.</a>
              <br />
              5. Contact us for help: 【contact@youmi.net】
            </p>
            <el-button class="back-login overlay-btn" @click="page_level = 1">
              Skip and login
            </el-button>
          </div>
        </el-form>

        <!--忘记密码-->
        <el-form
          v-if="page_level == 4"
          :model="emailForm"
          ref="emailForm"
          :rules="emailRules"
          @submit.native.prevent
          class="reset-psw-form"
        >
          <h2 class="reset-psw-title">
            <div>Retrieve Password</div>
            <div>
              Please enter the signed up email and you will receive an email to reset your password.
            </div>
          </h2>
          <el-form-item prop="verify_email">
            <label class="ym-label">Registered Account Email</label>
            <el-input
              class="reset-psw-input"
              type="email"
              autocomplete="off"
              placeholder="Email"
              v-model="emailForm.email"
              @keyup.native.stop="$event.keyCode == 13 ? onVerify() : ''"
            ></el-input>
          </el-form-item>
          <el-form-item prop="captcha">
            <label class="ym-label">Verification Code</label>
            <el-input
              class="reset-psw-input"
              v-model="emailForm.captcha"
              name="captcha"
              @keyup.native="$event.keyCode == 13 ? onVerify() : ''"
            >
              <template slot="append">
                <img
                  id="reset_psw_captcha"
                  class="captcha-img"
                  @click="src = '/api/common/get-captcha/?' + Math.random()"
                  :src="src"
                  alt="captcha"
                />
              </template>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button class="reset-psw-btn overlay-btn" type="primary" @click="onVerify">
              Confirm
            </el-button>
            <div class="reset-psw-back">
              <a @click="page_level = 1">Back to login</a>
            </div>
          </el-form-item>
        </el-form>

        <!--重置密码邮件发送-->
        <div v-if="page_level === 5" class="reset-psw-success">
          <h2>
            <i class="icon-y-success mr-1"></i>
            Check and Reset
          </h2>
          <div>
            <div class="sub-tit">Check your email address:</div>
            <div class="email">{{ emailForm.email }}</div>
            <div class="content">
              We have sent you an email, please click the link in the email to reset a new password.
              <br />
              If you can't find the mail, please check the spam.
            </div>
          </div>
          <el-button type="primary" class="check-btn overlay-btn" @click="checkResetPswEmail">
            Go and Check
          </el-button>
          <a class="no-received" @click="page_level = 3">No email received?</a>
        </div>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import commonAside from '../../components/commonAside'

export default {
  data() {
    return {
      loading: false,
      src: '/api/common/get-captcha/',
      signAsRole: '',
      page_level: 1,
      login: {
        orgtype: 3,
      },
      login_captcha_enable: false,
      emailForm: {},
      rules: {
        username: [
          { required: true, message: 'Can\'t be empty!', trigger: 'blur' },
          { type: 'email', message: 'Please enter the correct email', trigger: 'blur' },
        ],
        password: [{ required: true, message: 'Can\'t be empty!', trigger: 'blur' }],
        captcha: [{ validator: this.verifyCaptcha, trigger: ['blur'] }],
      },
      emailRules: {
        email: [
          { required: true, message: 'Can\'t be empty!', trigger: ['blur'] },
          { type: 'email', message: 'Please enter the correct email', trigger: ['blur'] },
        ],
        captcha: [{ validator: this.verifyCaptcha, trigger: ['blur'] }],
      },
    }
  },
  created() {
    this.$http.get('/accounts/login-info/').then(res => {
      if (res.status === 1) {
        this.routerChange('home')
      }
    })
  },
  methods: {
    Login() {
      this.$refs['loginForm'].validate(valid => {
        if (valid) {
          this.loading = true
          this.$http
            .post('/accounts/login-r/', this.login)
            .then(() => {
              this.loading = false
              this.routerChange('snapshot')
            })
            .catch(err => {
              this.loading = false
              let captcha = document.getElementById('login_captcha')
              if (captcha) {
                captcha.src = '/api/common/get-captcha/'
                this.captcha_status = false
              }
              switch (err.c) {
                case -1006: // 邮箱未验证
                  this.page_level = 2
                  this.$http.post('/accounts/email-send/', {
                    email: this.login.username,
                    template: 'account_active',
                  })
                  break
                case -1031: // captcha error
                  this.login_captcha_enable = true
                  this.notifyOpen('Error', this.executeError(err), 'error')
                  break
                default:
                  // network error
                  this.notifyOpen('Error', this.executeError(err), 'error')
              }
            })
        }
      })
    },

    verifyCaptcha(rule, value, callback) {
      let item = {}
      if (this.page_level === 1) {
        item.captcha = this.login.captcha
      }
      if (this.page_level === 4) {
        item.captcha = this.emailForm.captcha
      }
      this.$http
        .post('/api/common/check-captcha/', item)
        .then(() => {
          callback()
        })
        .catch(() => {
          callback(new Error('wrong captcha'))
        })
    },
    onVerify() {
      let verify = true
      let params = this.emailForm
      this.$refs['emailForm'].validate(valid => {
        if (!valid) {
          verify = false
        }
      })
      if (!verify) {
        return
      }

      this.$http
        .post('/accounts/forget/', params)
        .then(() => {
          this.page_level = 5
        })
        .catch(err => {
          let captcha = document.getElementById('reset_psw_captcha')
          if (captcha) {
            captcha.src = '/api/common/get-captcha/'
          }
          switch (err.c) {
            case -1031: // captcha error
              this.notifyOpen('Error', this.executeError(err), 'error')
              break
            case -1008: // email does not exist
              this.notifyOpen('Error', this.executeError(err), 'error')
              break
            case -1006: // email is not activated
              this.notifyOpen('Error', this.executeError(err), 'error')
              break
            default:
              // network error
              this.notifyOpen('Error', this.executeError(err), 'error')
          }
        })
    },
    checkEmail() {
      let mailAddress = this.login.username.split('@')[1]
      if (mailAddress) {
        if (mailAddress === 'gmail.com') {
          mailAddress = 'google.com'
        }
        window.open(`http://mail.${mailAddress}`, '_blank')
      }
    },
    checkResetPswEmail() {
      let mailAddress = this.emailForm.email.split('@')[1]
      if (mailAddress) {
        if (mailAddress === 'gmail.com') {
          mailAddress = 'google.com'
        }
        window.open(`http://mail.${mailAddress}`, '_blank')
      }
    },
    sendEmailAgain() {
      let params = {
        email: this.login.username,
        template: 'account_active',
      }
      this.$http
        .post('/accounts/email-send/', params)
        .then(res => {
          this.notifyOpen()
        })
        .catch(err => {
          this.notifyOpen('Error', this.executeError(err), 'error')
        })
    },
  },
  components: { commonAside },
}
</script>

<style lang="scss">
.aff-login {
  min-height: 100%;
  position: relative;
  display: flex;
  font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue', Helvetica, 'PingFang SC',
    'Hiragino Sans GB', 'Microsoft YaHei', '微软雅黑', Arial, sans-serif;
  .icon-grey {
    font-size: 16px;
    color: #c0c4cc;
    line-height: 22px;
  }
  .captcha-img {
    vertical-align: middle;
    height: 46px;
  }
  .content {
    background-color: #fafcff;
    margin-bottom: 0px;
    padding: 24px;
    position: relative;
    z-index: 1;
    .header {
      display: flex;
      justify-content: space-between;
      .logo {
        margin: 0 0 0 16px;
        .logo-img {
          width: 175px;
          height: auto;
        }
      }
      a {
        text-decoration: none;
      }
      .signup {
        width: 80px;
        height: 32px;
        border-radius: 4px;
        background: #e30077;
        color: #fff;
        font-size: 14px;
        font-weight: bold;
        line-height: 32px;
        text-align: center;
      }
      .signup::before {
        background-color: rgba(255, 255, 255, 0.2);
      }
    }
    .main-container {
      height: calc(100vh - 75px);
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: -75px;
    }
    .login-form {
      width: 464px;
      .login-title {
        display: flex;
        justify-content: space-between;
        color: #303133;
        margin-bottom: 24px;
        & div:first-child {
          font-size: 38px;
          font-weight: 600;
          line-height: 46px;
        }
        & div:last-child {
          align-self: flex-end;
          font-size: 22px;
          font-weight: 400;
        }
      }
      .el-form-item {
        margin-bottom: 24px;
      }
      .login-input {
        .el-input__inner {
          font-size: 16px;
          height: 48px;
          line-height: 48px;
        }
        .el-input-group__append {
          padding: 0;
        }
      }
      .remember-box {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        .remember-label {
          display: inline-block;
          font-size: 14px;
          color: #606266;
        }
        .el-checkbox__inner {
          width: 16px;
          height: 16px;
          &::after {
            left: 5px;
            top: 2px;
          }
        }
      }
      #remember {
        margin-right: 12px;
      }
      .forget {
        cursor: pointer;
        color: #1861f2;
      }
      .login-btn {
        width: 100%;
        height: 48px;
        border-radius: 4px;
        background: #1861f2;
        color: #fff;
        font-size: 16px;
        font-weight: bold;
        border-style: none;
        margin-top: 16px;
      }
      .login-btn::before {
        background-color: rgba(255, 255, 255, 0.2);
      }
    }

    .verify-form {
      width: 464px;
      color: #303133;
      .verify-title {
        display: flex;
        justify-content: space-between;
        margin-bottom: 24px;
        & div:first-child {
          font-size: 38px;
          font-weight: 600;
          line-height: 46px;
        }
        & div:last-child {
          align-self: flex-end;
          font-size: 20px;
          font-weight: 400;
          line-height: 28px;
        }
      }
      .verify-content {
        background: #ffffff;
        border: 1px solid #ebeef5;
        border-radius: 8px;
        padding: 32px;
        .verify-sub-tit {
          text-align: center;
          margin-bottom: 24px;
          i {
            vertical-align: 2px;
          }
          label {
            font-size: 30px;
            font-weight: 600;
            line-height: 38px;
          }
        }
        .check {
          font-weight: 600;
          margin-bottom: 4px;
        }
        .email {
          color: #1861f2;
          font-weight: 600;
          margin-bottom: 12px;
          line-height: 24px;
        }
        .desc {
          color: #606266;
          line-height: 22px;
          margin-bottom: 24px;
        }
        .btn-area {
          display: flex;
          justify-content: space-between;
          .verify-btn {
            font-size: 14px;
            font-weight: bold;
            width: 192px;
            height: 40px;
            color: #ffffff;
            border-radius: 4px;
            border: none;
          }
          .verify-btn::before {
            background-color: rgba(255, 255, 255, 0.2);
          }
          .back-login {
            background: #1861f2;
          }
          .go-check {
            background: #e30077;
          }
        }
        .no-email {
          display: flex;
          justify-content: flex-end;
          margin-right: 20px;
          a {
            color: #1861f2;
          }
        }
      }
    }

    .no-email-form {
      width: 464px;
      color: #303133;
      .no-email-title {
        display: flex;
        justify-content: space-between;
        margin-bottom: 24px;
        & div:first-child {
          font-size: 38px;
          font-weight: 600;
          line-height: 46px;
        }
        & div:last-child {
          align-self: flex-end;
          font-size: 20px;
          font-weight: 400;
          line-height: 28px;
        }
      }
      .no-email-content {
        background: #ffffff;
        border: 1px solid #ebeef5;
        border-radius: 8px;
        padding: 32px;
        a {
          color: #1861f2;
        }
        .no-email-sub-tit {
          text-align: center;
          color: #303133;
          height: 38px;
          line-height: 38px;
          margin-bottom: 24px;
          i.icon-y-yiwen1 {
            vertical-align: 2px;
          }
          .sub-tit {
            font-size: 30px;
            font-weight: 600;
          }
        }
        .solutions {
          color: #303133;
          font-size: 16px;
          font-weight: 600;
          line-height: 24px;
        }
        .solutions-content {
          color: #606266;
          line-height: 22px;
        }
        .back-login {
          width: 100%;
          height: 40px;
          background: #1861f2;
          border-radius: 4px;
          margin-top: 24px;
          border: none;
          color: #ffffff;
          font-size: 14px;
          font-weight: bold;
        }
        .back-login::before {
          background: rgba(255, 255, 255, 0.2);
        }
      }
    }

    .reset-psw-form {
      width: 464px;
      .reset-psw-title {
        color: #303133;
        margin-bottom: 24px;
        & div:first-child {
          font-size: 38px;
          font-weight: 600;
          line-height: 46px;
        }
        & div:last-child {
          font-size: 20px;
          font-weight: 400;
          line-height: 28px;
        }
      }
      .el-form-item {
        margin-bottom: 24px;
      }
      .reset-psw-input {
        .el-input__inner {
          font-size: 16px;
          height: 48px;
          line-height: 48px;
        }
        .el-input-group__append {
          padding: 0;
        }
      }
      .reset-psw-btn {
        width: 100%;
        height: 48px;
        border-radius: 4px;
        background: #1861f2;
        color: #fff;
        font-size: 16px;
        font-weight: bold;
        border-style: none;
        margin-top: 16px;
      }
      .reset-psw-btn::before {
        background: rgba(255, 255, 255, 0.2);
      }
      .reset-psw-back {
        text-align: center;
        margin-top: 16px;
        a {
          color: #1861f2;
        }
      }
    }

    .reset-psw-success {
      width: 464px;
      height: 362px;
      background: #fff;
      border-radius: 8px;
      border: 1px solid rgba(235, 238, 245, 1);
      margin: 80px auto 0;
      box-sizing: border-box;
      padding: 32px;
      h2 {
        text-align: center;
        font-size: 30px;
        color: #303133;
        margin: 0 0 24px 0;
        i {
          color: #77b300;
          font-size: 24px;
          vertical-align: 2px;
        }
      }
      .sub-tit {
        color: #303133;
        font-weight: 600;
        line-height: 24px;
        margin-bottom: 4px;
      }
      .email {
        color: #1861f2;
        font-weight: 600;
        line-height: 24px;
        margin-bottom: 12px;
      }
      .content {
        color: #606266;
        line-height: 22px;
        margin-bottom: 24px;
        padding: 0;
      }
      .check-btn {
        width: 100%;
        height: 40px;
        background: #e30077;
        font-weight: bold;
        border-radius: 4px;
        border: none;
        margin-bottom: 8px;
      }
      .check-btn::before {
        background: rgba(255, 255, 255, 0.2);
      }
      .no-received {
        color: #1861f2;
        display: block;
        width: 125px;
        margin: 0 auto;
      }
    }
  }
  @media screen and (max-width: 1270px) {
    .aside {
      width: 50% !important;
    }
  }
  @media screen and (max-width: 1000px) {
    .aside {
      display: none;
    }
  }
}
.ym-label {
  display: inline-block;
  font-size: 16px;
  color: #606266;
  margin-bottom: 8px;
}
</style>
